import React from 'react';
import { Link } from 'react-router-dom';
import { Badge, BadgeVariant } from '../shared/Badge';
import './AttentionRequired.css';

export interface AttentionItem {
  severity: 'Critical' | 'High' | 'Medium' | 'Low';
  text: string;
  action: string;
  link: string;
}

interface Props {
  items: AttentionItem[];
  loading: boolean;
}

const SEVERITY_VARIANT: Record<string, BadgeVariant> = {
  Critical: 'danger',
  High: 'warning',
  Medium: 'info',
  Low: 'neutral',
};

export const AttentionRequired: React.FC<Props> = ({ items, loading }) => (
  <div className="ar-card">
    <div className="ar-header"><h3>Attention Required</h3></div>
    {loading ? (
      <div className="ar-skeleton" />
    ) : items.length === 0 ? (
      <div className="ar-clear">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#16a34a" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg>
        No active risks — all systems nominal.
      </div>
    ) : (
      <ul className="ar-list">
        {items.map((item, i) => (
          <li key={i} className="ar-item">
            <Badge variant={SEVERITY_VARIANT[item.severity] || 'neutral'}>{item.severity}</Badge>
            <div className="ar-item-body">
              <span className="ar-item-text">{item.text}</span>
              <Link to={item.link} className="ar-item-action">{item.action} →</Link>
            </div>
          </li>
        ))}
      </ul>
    )}
  </div>
);

export default AttentionRequired;
